import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import "./PageInfoButton.css";

const PageInfoButton = ({ title = "About", children }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return;

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [open]);

  return (
    <>
      <button
        type="button"
        className="page-info-button"
        aria-label={`About ${title}`}
        onClick={() => setOpen(true)}
      >
        <FontAwesomeIcon icon={faCircleInfo} />
      </button>

      {open && (
        <div className="page-info-modal" role="dialog" aria-modal="true" aria-label={`${title} details`}>
          <div className="page-info-backdrop" onClick={() => setOpen(false)} />
          <div className="page-info-card">
            <div className="page-info-card-header">
              <h3>{title}</h3>
              <button className="page-info-close" aria-label="Close about dialog" onClick={() => setOpen(false)}>
                ×
              </button>
            </div>
            <div className="page-info-body">{children}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default PageInfoButton;
